<div class="login-container">
  <div class="login-card">
    <h1>Licensing</h1>
    <p>Redirecting to login...</p>
    <div class="spinner"></div>
  </div>
</div>
